export default __webpack_public_path__ + "static/performance-e66714557348bfe193a7a1761e2ec936.jpg";